import { render, staticRenderFns } from "./StudioContact.vue?vue&type=template&id=63a42b54&scoped=true"
import script from "./StudioContact.vue?vue&type=script&lang=js"
export * from "./StudioContact.vue?vue&type=script&lang=js"
import style0 from "./StudioContact.vue?vue&type=style&index=0&id=63a42b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a42b54",
  null
  
)

export default component.exports